var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgSimpleCheck = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3e704b",
    d: "M11.618 0c-.35.01-.68.158-.924.412-2.127 2.16-4.068 4.277-6.11 6.39l-2.4-1.95a1.33 1.33 0 00-1.89.213 1.377 1.377 0 00.21 1.915l3.36 2.723a1.33 1.33 0 001.791-.106c2.416-2.454 4.581-4.865 6.942-7.263.395-.393.512-.99.296-1.505a1.343 1.343 0 00-1.275-.828z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSimpleCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/simple-check.66c3eee0.svg";
export { ForwardRef as ReactComponent };